import * as React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

export const StopWatch = (props: SvgProps) => (
  <Svg viewBox='0 0 16 21' fill='none' {...props}>
    <Path
      d='M8 19.129c3.866 0 7-3.144 7-7.022s-3.134-7.022-7-7.022-7 3.144-7 7.022 3.134 7.022 7 7.022Z'
      stroke='currentColor'
      strokeWidth={2}
      strokeMiterlimit={10}
    />
    <Path
      d='m8 12.107 2.03-2.062M6.022 1h3.955'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </Svg>
)
